<template>
    <card v-if="simulation && hasRevisions">
        <h3 class="text-uppercase text-left mb-4">{{ $t('sessions.revisions') }}</h3>
        <div class="text-left mb-4">

            <div class="mb-3" v-for="(revision, index) in simulation.state.revisions" :key="index">

                <i class="fas fa-thumbtack float-left text-muted"></i>

                <div class="pl-4">
                    <p><strong>
                        {{ revision.author_name }} ({{ revision.date }})
                    </strong></p>
                    <!-- Keep it on a single line -->
                    <p class="comment">{{ revision.comment }}</p>
                </div>
            </div>
        </div>
    </card>
</template>

<script>
    export default {

        props: {
            simulation: {
                type: Object,
                required: true
            },
        },

        computed: {
            hasRevisions() {
                return this.simulation && this.simulation.state.revisions
            }
        }
    }
</script>

<style scoped>

    .comment {
        white-space: pre-wrap;
    }
    p {
        font-size: 80%;
        margin-bottom: 0;
    }
    strong {
        font-weight: 700;
    }
    i {
        font-size: 80%;
        position: relative;
        top: 5px;
    }

</style>
